import { useRef } from 'react'
import { useSelector } from 'react-redux'
import {
  Box,
  Card,
  CardBody,
  CardHeader
} from '@chakra-ui/react'
import { usersSelectors } from 'store'

import { RequestItems } from '../RequestItems'

export const BlockedRequest = () => {
  const { blockedRequest } = useSelector(usersSelectors)
  const cardRef = useRef()

  return (
    <Card
      ref={cardRef}
      boxShadow="none"
      marginTop="0px !important"
      background="#c4c3c7"
    >
      <CardHeader
        display="flex"
        alignItems="center"
        padding="0 10px"
        background="#feeb88"
      >
        <Box
          textAlign="left"
          paddingRight="10px"
        >
          Blocked Profiles
        </Box>
      </CardHeader>

      <CardBody
        padding="5px"
        minHeight="130px"
        maxHeight="130px"
      >
        <Box
          overflow="auto"
          display="flex"
          flexDirection="row"
          gap="10px"
          css={{
            '&::-webkit-scrollbar': {
              width: '4px',
              height: '10px',
              display: 'block'
            },
            '&::-webkit-scrollbar-track': {
              width: '6px'
            },
            '&::-webkit-scrollbar-thumb': {
              borderRadius: '24px',
              background: 'rgba(255, 215, 0, 1)'
            }
          }}
        >
          {
            blockedRequest?.length
              ? (
                <RequestItems
                  notificationItems={blockedRequest}
                  type="blocked"
                />
              )
              : <div>No notifications to display</div>
          }
        </Box>
      </CardBody>
    </Card>
  )
}
